import { styled } from '@material-ui/core/styles';

export default styled('div')(({ theme }) => ({
  margin: theme.spacing(2, 0, 6),
}));
